(() => {
	// ============================================
	// 初回アクセス判定
	// ============================================
	const LOADING_KEY = 'reignite_loading_played';
	const isPlayed = sessionStorage.getItem(LOADING_KEY);

	// ============================================
	// 2回目以降
	// ============================================
	if (isPlayed) {

		const loadEl = document.querySelector('[data-load]');

		if (loadEl) {
			loadEl.classList.add('is-target-hide');
		}

		document.documentElement.classList.add(
			'is-finishLoad'
		);

		document.dispatchEvent(
			new CustomEvent('loadingComplete')
		);

		return;
	}

	// ============================================
	// ローディング状態
	// ============================================
	let isCountFinished = false;
	let isLoadingFinished = false;

	/**
	 * ローディング終了処理
	 * @param {Element} loadEl
	 */
	const finishLoading = loadEl => {
		if (!isCountFinished || !isLoadingFinished) {
			return;
		}

		loadEl.classList.add('is-fadeOut');

		setTimeout(() => {

			loadEl.classList.add('is-target-hide');

			document.documentElement.classList.add(
				'is-finishLoad'
			);

			// ============================================
			// ローディング完了後に初回済みとして記録
			// ============================================
			sessionStorage.setItem(
				LOADING_KEY,
				'true'
			);

			document.dispatchEvent(
				new CustomEvent('loadingComplete')
			);

		}, 200);
	};

	/**
 * ローディングアニメーション
 * @param {object} param
 */
	const loadingAnimation = ({
		loadEl,
		cntTargetEl
	}) => {

		// 初回アクセスのみローディングを表示
		loadEl.classList.add('is-loading');

		// is-loadingを画面に反映してからカウントアップ開始
		requestAnimationFrame(() => {

			const duration = 1800;
			const from = 0;
			const to = 100;
			const increment = to - from;
			const startTime = performance.now();

			const cntUp = () => {

				const elapsed =
					performance.now() - startTime;

				const cntVal =
					from +
					((elapsed / duration) * increment);

				if (cntVal >= to) {

					cntTargetEl.innerText =
						to.toLocaleString();

					isCountFinished = true;

					finishLoading(loadEl);

				} else {

					cntTargetEl.innerText =
						Math.floor(cntVal).toLocaleString();

					requestAnimationFrame(cntUp);
				}
			};

			requestAnimationFrame(cntUp);
		});
	};

	/**
	 * DOM取得
	 */
	const getElList = () => {
		const loadEl =
			document.querySelector('[data-load]');

		const cntTargetEl =
			document.querySelector('[data-cnt-target]');

		if (!loadEl || !cntTargetEl) {
			return;
		}

		return {
			loadEl,
			cntTargetEl
		};
	};

	/**
	 * 実行
	 */
	const initLoadingAnimation = () => {
		const elList = getElList();

		if (!elList) {
			return;
		}

		loadingAnimation(elList);

		window.addEventListener('load', () => {
			isLoadingFinished = true;
			finishLoading(elList.loadEl);
		});
	};

	initLoadingAnimation();
})();
